module.exports = __webpack_public_path__ + "static/media/asia-jungle.9bdb17fd.jpg";